module.exports = __webpack_public_path__ + "media/images/welcome-talent-d0b5e585ea99a048577b690c027e6750.svg";